// ** React Imports
import { Outlet } from 'react-router-dom'
import { useState, useEffect } from 'react'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

// ** Menu Items Array
// import navigation from '@src/navigation/vertical'

import { backendRequest } from '@src/@core/auth/apiService'
/* import { configJobBattute } from '../@core/auth/apiService/configs'
import axios from 'axios'
let time = 1 */
const VerticalLayout = props => {
  const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  useEffect(() => {
    backendRequest({}, 'Utente', 'getMenuUtente').then(response => setMenuData(JSON.parse(response.menu)))
  }, [])
  //jobBattute
  /* const jobBattute = async () => {
    await axios(configJobBattute())
  }
  const interval = setInterval(() => {
    if (time <= 1) {
      jobBattute()
      time += 1
    } else {
      clearInterval(interval)

    }
  }, 3000) */

  return (
    <Layout menuData={menuData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
